import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LineItem } from '../../objects/line-item';
import { LineItemRequest } from '../../objects/line-item-request';
import { Order } from '../../objects/order';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LineItemService extends BaseService {
  createInstance = (attributes: LineItem): LineItem => attributes;

  createLineItem(args: {
    request: LineItemRequest;
  }): Observable<LineItem[]> {
    const {
      product,
      order,
      destination,
    } = args.request;

    const url = `orders/current/${order.token}/products/${product.id}/${destination.id}`;
    const payload = args.request.toJSON();

    return super.doCreate(payload, url);
  }

  destroyLineItem(payload: { item: LineItem; order: Order }): Observable<Order> {
    const url = `${this.baseUrl}/orders/current/${payload.order.token}/line_items/${payload.item.id}`;

    return this.http.delete<Order>(url);
  }
}
